import React, { useState, useEffect } from 'react';
import moment from 'moment';
import DateRangePicker from 'react-dates/lib/components/DateRangePicker';
import 'react-dates/initialize';
import DatepickerArrow from './DatepickerArrow';
import useWindowSize from '../hooks/useWindowSize';

export default function NewListingSpecialDate({ start_date, end_date }) {
  const [localStartDate, setLocalStartDate] = useState(null);
  const [localEndDate, setLocalEndDate] = useState(null);
  const [focusedState, setFocusedState] = useState(null);

  useEffect(() => {
    // Moment parses star_date/end_date behind 1 day
    if (start_date) setLocalStartDate(moment(start_date).add(1, 'd'));
    if (end_date) setLocalEndDate(moment(end_date).add(1, 'd'));
    const datePickerWrappers = document.querySelectorAll(
      '.DateInput.DateInput_1'
    );
    // Add input class for styling
    datePickerWrappers.forEach(node => {
      node.classList.add('input');
    });
    // Create Start Date Label
    const startDateLabel = document.createElement('label');
    startDateLabel.appendChild(document.createTextNode('Start Date*'));
    // Create End Date Label
    const endDateLabel = document.createElement('label');
    endDateLabel.appendChild(document.createTextNode('End Date*'));
    // Append Start Date Label
    datePickerWrappers[0].insertBefore(
      startDateLabel,
      datePickerWrappers[0].childNodes[0]
    );
    // Append End Date Label
    datePickerWrappers[1].insertBefore(
      endDateLabel,
      datePickerWrappers[1].childNodes[0]
    );
  }, [end_date, start_date]);

  const { width: windowWidth } = useWindowSize();

  return (
    <div className="custom-calendar-wrapper listing-special">
      <DateRangePicker
        startDate={localStartDate}
        endDate={localEndDate}
        startDatePlaceholderText="Select Start Date"
        endDatePlaceholderText="Select End Date"
        displayFormat="MMM DD, YYYY"
        onDatesChange={({ startDate, endDate }) => {
          setLocalStartDate(startDate);
          setLocalEndDate(endDate);
          if (startDate)
            document.querySelector(
              '#listing_special_start_date'
            ).value = startDate.format('YYYY-MM-DD');
          if (endDate)
            document.querySelector(
              '#listing_special_end_date'
            ).value = endDate.format('YYYY-MM-DD');
        }}
        openDirection="OPEN_DOWN"
        focusedInput={focusedState}
        onFocusChange={e => setFocusedState(e)}
        numberOfMonths={windowWidth <= 630 ? 1 : 2}
        noBorder
        navNext={<DatepickerArrow direction="next" />}
        navPrev={<DatepickerArrow direction="prev" />}
        isDayBlocked={day => {
          // block all days before today
          if (day.isBefore(moment().format('MM-DD-YYYY'))) {
            return true;
          }
        }}
      />
    </div>
  );
}
